import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TEAM_SETUP_TIMEZONE', function setTeamSetupTimezone(timeZoneOlsonCode: string) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.timeZoneOlsonCode = timeZoneOlsonCode;
    }
});
